<template>
  <section class="forbidden-user">
    <img
      :src="'/generic/reportesSindatos.png' | baseImg"
      alt="Sin privilegios"
    />
    <h1>Sin privilegios.</h1>
    <h4>Su usuario no tiene permisos adecuados para el uso de la aplicación web</h4>
    <button
      @click="logout"
      class="btn btn-primary"
    >Salir</button>
  </section>
</template>

<script>
export default {
  name: "dep-forbidden",
  methods: {
    logout() {
      this.$store.dispatch("User/logout");
      this.$router.replace("/login");
    },
  },
};
</script>

<style lang="scss">
.forbidden-user {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  img {
    max-width: 200px;
  }
}
</style>